import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ExternalLinkIcon = () => {
  return /*#__PURE__*/_jsxs("svg", {
    fill: "none",
    height: "18",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
    width: "18",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }), /*#__PURE__*/_jsx("polyline", {
      points: "15 3 21 3 21 9"
    }), /*#__PURE__*/_jsx("line", {
      x1: "10",
      x2: "21",
      y1: "14",
      y2: "3"
    })]
  });
};